import moment from "moment";

const TimeUtils = {
    /**
     *
     * @param period
     * @param customStartTS
     * @param customEndTS
     * @returns {{endTS: *, startTS: *}|{endTS: null, startTS: null}}
     */
    calculatePeriod: (period, customStartTS, customEndTS) => {
        if (customStartTS || customEndTS) {
            let startTS = customStartTS ? moment(customStartTS, "YYYY-MM-DD").startOf("day").toDate() : null;
            let endTS = customEndTS ? moment(customEndTS, "YYYY-MM-DD").endOf("day").toDate() : null;
            return { startTS, endTS };
        }
        if (period) {
            const validPeriods = [
                "today",
                "yesterday",
                "last7",
                "last30",
                "this-month",
                "last-month",
                "last-3-month",
                "this-year",
                "last-year",
            ];

            if (validPeriods.includes(period)) {
                let startTS = moment().startOf("day").toDate();
                let endTS = moment().endOf("day").toDate();
                if (period === "today") {
                    startTS = moment().startOf("day").toDate();
                    endTS = moment().endOf("day").toDate();
                } else if (period === "yesterday") {
                    startTS = moment().subtract(1, "days").startOf("day").toDate();
                    endTS = moment().subtract(1, "days").endOf("day").toDate();
                } else if (period === "last7") {
                    startTS = moment().subtract(6, "days").startOf("day").toDate();
                    endTS = moment().endOf("day").toDate();
                } else if (period === "last30") {
                    startTS = moment().subtract(29, "days").startOf("day").toDate();
                    endTS = moment().endOf("day").toDate();
                } else if (period === "this-month") {
                    startTS = moment().startOf("month").toDate();
                    endTS = moment().endOf("month").toDate();
                } else if (period === "last-month") {
                    startTS = moment().subtract(1, "months").startOf("month").toDate();
                    endTS = moment().subtract(1, "months").endOf("month").toDate();
                } else if (period === "last-3-month") {
                    startTS = moment().subtract(3, "months").startOf("month").toDate();
                    endTS = moment().endOf("day").toDate();
                } else if (period === "this-year") {
                    startTS = moment().startOf("year").toDate();
                    endTS = moment().endOf("year").toDate();
                } else if (period === "last-year") {
                    startTS = moment().subtract(1, "years").startOf("year").toDate();
                    endTS = moment(startTS).endOf("year").toDate();
                }
                return { startTS, endTS };
            }
        }
        return { startTS: null, endTS: null };
    },
    getLast11Months: () => {
        let months = [];

        for (let i = 1; i < 12; i++) {
            const date = moment().clone().subtract(i, "months");
            window.moment = moment;
            const obj = {
                name: date.format("MMMM YYYY"),
                date: {
                    start: date.clone().startOf("month").utc().toISOString(),
                    end: date.clone().endOf("month").utc().toISOString(),
                },
            };
            months.push(JSON.parse(JSON.stringify(obj)));
        }

        return months;
    },
    getTimezone() {
        return moment.tz.guess();
    },
};

export default TimeUtils;
